<snelstart-ui-dialog-definition id="us" title="Aanvullend uitstel of afmelden" size="lg"
                                [(visible)]="this.dialogVisible">
  <snelstart-ui-dialog-header-content>
    Vor regulier BECON uitstel geef je bij de klantinstellingen aan dat je de klant wilt opnemen
    in de uitstelregeling. Wij vragen dan automatisch beconuitstel voor je aan.
    Gebruik onderstaand formulier alleen om aanvullend uitstel aan te vragen of om de klant af te melden
    voor beconuitstel.
  </snelstart-ui-dialog-header-content>
  <snelstart-ui-dialog-body [formGroup]="uitstelFg">
    <snelstart-ui-bsn-form-control formControlName="fiscaalNummer"
                                   id="fiscaalNummer"
                                   label="Fiscaal nummer"
                                   class="custom-input-250"
                                   (change)="this.saveForm()">
    </snelstart-ui-bsn-form-control>
    <snelstart-ui-select-form-control formControlName="belastingmiddel"
                                      id="belastingmiddel"
                                      label="Belastingmiddel"
                                      class="custom-input-250"
                                      [options]="optionsMiddelUitstel"
                                      (change)="this.saveForm()"
    >
    </snelstart-ui-select-form-control>
    <snelstart-ui-select-form-control formControlName="soortUitstelVerzoek"
                                      id="soortUitstelVerzoek"
                                      label="Type uitstel"
                                      class="custom-input-250"
                                      [options]="optionsSoortUitstel"
                                      (change)="this.saveForm()">
    </snelstart-ui-select-form-control>
    @if(this.uitstelFg.get('soortUitstelVerzoek')?.value === UitstelGegevensSoortUitstelVerzoek.AANVULLEND_UITSTEL) {
      <snelstart-ui-textarea-form-control formControlName="motivatieBijzonderUitstel"
                                          id="motivatieBijzonderUitstel1"
                                          label="Toelichting aanvullend uitstel"
                                          [rows]="7"
                                          (change)="this.saveForm()">
      </snelstart-ui-textarea-form-control>
    }
    @if (this.uitstelFg.get('belastingmiddel')?.value === UitstelGegevensBelastingmiddel.VENNOOTSCHAPSBELASTING) {
      <snelstart-ui-date-form-control formControlName="boekjaarStart"
                                      id="boekjaarStart"
                                      placeholder="01-01-{{this.year}}"
                                      class="custom-input-250"
                                      label="Start boekjaar"
                                      (change)="this.saveForm()">
      </snelstart-ui-date-form-control>
      <snelstart-ui-date-form-control formControlName="boekjaarEind"
                                      id="boekjaarEind"
                                      placeholder="31-12-{{this.year}}"
                                      class="custom-input-250"
                                      label="Eind boekjaar"
                                      (change)="this.saveForm()">
      </snelstart-ui-date-form-control>
    }
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button id="cancel" class="me-1" type="secondary" btn-x (click)="this.dialogVisibleChange.emit(false); this.uitstelFg.reset()">
      Annuleren
    </snelstart-ui-button>
    <snelstart-ui-button id="save" type="primary" icon="check" (click)="postUitstelGegevens()">Verzenden
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
